import { FaqSchema } from "@/components/FaqSchema";
import { ContentPageNav } from "@/components/ContentPageNav";
import { Footer } from "@/components/Footer";

const html = `<nav aria-label="Kruimelpad" class="px-3 pt-4 pb-2"><div class="container mx-auto max-w-6xl"><ol class="flex flex-wrap items-center gap-2 text-sm"><li class="flex items-center gap-2"><a href="/" class="text-muted-foreground hover:text-foreground transition-colors">Home</a></li><li class="text-foreground font-medium" aria-current="page">5 manieren voor meer spelers</li></ol></div></nav>

  <header class="py-10 md:py-20 px-3">
    <div class="container mx-auto max-w-3xl">
      <h1 class="text-3xl md:text-5xl font-bold text-foreground mb-6">5 manieren om meer spelers naar je husselavond te trekken</h1>
      <p class="text-lg md:text-xl text-muted-foreground leading-relaxed">Veel tennisverenigingen worstelen met dezelfde vraag: hoe krijg je <strong>meer spelers naar je husselavond</strong>? We verzamelden 5 tactieken die op echte clubs hebben gewerkt.</p>
    </div>
  </header>

  <article class="px-3 pb-6">
    <div class="container mx-auto max-w-3xl space-y-8">
      
        <section>
          <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-4">1. Vast moment, vaste verwachting</h2>
          <div class="text-muted-foreground leading-relaxed space-y-4"><p>Leden komen vaker als ze weten dat het altijd <em>dinsdagavond 19:30</em> is. Een vast wekelijks ritueel creëert routine — en routine wint van enthousiasme.</p></div>
        </section>
        <section>
          <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-4">2. Maak aanmelden 1-tik-werk</h2>
          <div class="text-muted-foreground leading-relaxed space-y-4"><p>Iedere extra klik kost deelnemers. Een lijst in de kantine of een groepsapp werkt niet. Een dedicated app waar je in één tik aanmeldt, wel. Spelers die zich op vrijdag bedenken om dinsdag te spelen, moeten dat <em>nu</em> kunnen doen, niet later.</p></div>
        </section>
        <section>
          <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-4">3. Push-meldingen: subtiel maar krachtig</h2>
          <div class="text-muted-foreground leading-relaxed space-y-4"><p>Een vriendelijk "💪 De husselavond start over 24 uur — meld je aan!" zorgt voor 20–30% meer aanmeldingen. Belangrijk: niet spammen. Eén reminder per sessie is genoeg.</p></div>
        </section>
        <section>
          <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-4">4. Mix niveaus slim</h2>
          <div class="text-muted-foreground leading-relaxed space-y-4"><p>Spelers haken af als ze elke week tegen dezelfde te-sterke tegenstander spelen. Een goed indelingsalgoritme houdt rekening met niveauverschillen zonder dat sterke en zwakke spelers nooit tegen elkaar uitkomen. Een gevoel van "ik kan winnen" houdt mensen terug.</p></div>
        </section>
        <section>
          <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-4">5. Vier de winnaars (een beetje)</h2>
          <div class="text-muted-foreground leading-relaxed space-y-4"><p>Een kleine ranglijst, een "speler van de maand" of een seizoenscompetitie — gamification werkt. Maar overdrijf niet: de meeste leden komen voor de gezelligheid, niet voor een beker.</p></div>
        </section>
        <section>
          <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-4">Bonus: kantine open houden</h2>
          <div class="text-muted-foreground leading-relaxed space-y-4"><p>Na de laatste ronde nablijven met een drankje is voor veel leden net zo belangrijk als het spelen zelf. Stem af met je kantinevrijwilligers.</p></div>
        </section>
    </div>
  </article>

  <section class="py-10 md:py-16 px-3">
    <div class="container mx-auto max-w-3xl">
      <div class="p-5 md:p-10 text-center rounded-lg border border-accent/30 bg-accent/10">
        <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-4">Klaar om dit voor je club te automatiseren?</h2>
        <p class="text-lg text-muted-foreground mb-6">De Hussel App regelt aanmelden, indelen en push-meldingen — voor husselen, tossen en racket trekken.</p>
        <a href="/club-register" class="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-accent text-accent-foreground font-medium hover:bg-accent/90 transition-colors">Registreer je club </a>
      </div>
    </div>
  </section>

  
  <section class="py-10 md:py-16 px-3">
    <div class="container mx-auto max-w-4xl">
      <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-6 md:mb-8 text-center">Veelgestelde vragen</h2>
      <div class="space-y-3">
    <details class="group rounded-lg border border-border bg-card p-4 md:p-5">
      <summary class="flex items-center justify-between gap-3 cursor-pointer list-none">
        <h3 class="text-base md:text-lg font-semibold text-foreground">Hoeveel spelers zijn een &quot;goede&quot; opkomst?</h3>
        
      </summary>
      <div class="mt-3 text-muted-foreground leading-relaxed">Vuistregel: 60–75% van je actieve recreatieleden komt regelmatig. Voor een club van 200 leden: 30–40 vaste husselaars is gezond.</div>
    </details>
    <details class="group rounded-lg border border-border bg-card p-4 md:p-5">
      <summary class="flex items-center justify-between gap-3 cursor-pointer list-none">
        <h3 class="text-base md:text-lg font-semibold text-foreground">Werkt een groepsapp niet net zo goed als een echte app?</h3>
        
      </summary>
      <div class="mt-3 text-muted-foreground leading-relaxed">Op de korte termijn wel. Op de lange termijn niet: groepsapps geven geen overzicht, geen statistieken en geen automatische indeling. Voor 2-3 husselaars werkt het, voor 30+ niet meer.</div>
    </details>
    <details class="group rounded-lg border border-border bg-card p-4 md:p-5">
      <summary class="flex items-center justify-between gap-3 cursor-pointer list-none">
        <h3 class="text-base md:text-lg font-semibold text-foreground">Is gamification niet kinderachtig voor volwassenen?</h3>
        
      </summary>
      <div class="mt-3 text-muted-foreground leading-relaxed">Subtiel werkt het. Een eenvoudige "wie heeft het vaakst gespeeld dit seizoen?" — meer hoef je niet. Trofeeën en badges zijn vaak too much.</div>
    </details></div>
    </div>
  </section>`;

const BlogMeerSpelers = () => {
  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground">
      <ContentPageNav showPricing />
      <div
        className="flex-1 marketing-content"
        dangerouslySetInnerHTML={{ __html: html }}
      />
      <FaqSchema html={html} />
      <Footer />
    </div>
  );
};

export default BlogMeerSpelers;
